import React, { useEffect, useState } from "react";
import { FaFile } from "react-icons/fa";
import { FaFileSignature } from "react-icons/fa";

export default function ContractAnimation() {
    const [showSignedIcon, setShowSignedIcon] = useState<boolean>(false);

    useEffect((): (() => void) => {
        const intervalId: ReturnType<typeof setInterval> = setInterval((): void => {
            setShowSignedIcon((currentValue: boolean): boolean => !currentValue);
        }, 1400);

        return (): void => clearInterval(intervalId);
    }, []);

    return (
        <div className="speed-interactive-container">
          <div
            className="speed-interactive-icon"
            style={{
              background: 'var(--launch-colour)',
              transition: 'transform 0.3s ease, opacity 0.3s ease',
              transform: showSignedIcon ? 'rotate(10deg) scale(1.03)' : 'rotate(10deg) scale(1)',
            }}
          >
            {showSignedIcon ? (
              <FaFileSignature size={24} fill="#fff"  />
            ) : (
              <FaFile size={24} fill="#fff" />
            )}
          </div>
        </div>
    );
}